// @flow
import * as React from 'react';
import FlipperContent, {
    BrightnessFlipperContent,
    BrightnessFlipperIcon,
    BrightnessFlipperWrapper,
    FlipperMessage
} from '../styles';

import BounceEffect from '~/components/widgets/bounce-effect';
import CircleWithHitArea from './hit-circle';
import devicesIcons from '~/core/constants/icons/devices-svg';
import Flipper from '~/components/widgets/flipper';
import { FormattedMessage } from 'react-intl';
import type { List } from 'immutable';
import messages from '~/core/i18n/components/widgets/flipper/intl';
import { noop } from 'lodash/fp';
import { VelocityComponent } from 'velocity-react';

type Props = {
    isGroup: boolean,
    isOn?: boolean,
    isSaving?: boolean,
    isSmall?: boolean,
    isToggling?: boolean,
    isVariableColour?: boolean,
    items: List<*>,
    rgb?: Uint8ClampedArray,
    toggleLightbulb: noop,
    value?: number,
    valueChanged: noop
};

// $FlowFixMe
const BrightnessFlipper = ({
    isGroup,
    items,
    value,
    valueChanged,
    isOn,
    isSaving,
    isToggling,
    toggleLightbulb,
    rgb,
    isVariableColour,
    isSmall
}: Props) => (
    <BrightnessFlipperWrapper>
        <VelocityComponent animation={{ zIndex: 2 }} delay={400} runOnMount>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                {items.map((item, i) => (
                    <CircleWithHitArea
                        delay={i * 30 + 300}
                        disabled={!isOn || isToggling}
                        isVariableColour={isVariableColour}
                        items={items}
                        key={item.get('value')}
                        onClick={() => valueChanged(item.get('value'))}
                        purpose={item.get('value')}
                        rgb={rgb}
                        rScale={item.get('rScale')}
                        selectedValue={value}
                        value={item.get('value')}
                        xFactor={item.get('xFactor')}
                        yFactor={item.get('yFactor')}
                    />
                ))}
            </svg>
        </VelocityComponent>
        <BrightnessFlipperContent>
            <Flipper childKey={isOn ? 'show' : 'hide'}>
                <div>
                    <BounceEffect isWaiting={isToggling || isSaving}>
                        <FlipperContent
                            isActive={isOn}
                            isSmall={isSmall}
                            isVariableColour={isVariableColour}
                            onClick={toggleLightbulb}
                            rgb={rgb}
                            style={{
                                background: rgb && isVariableColour && isOn ? `rgb(${rgb.toString()})` : '#FFFFFF'
                            }}
                        >
                            <BrightnessFlipperIcon
                                isActive={isOn}
                                isVariableColour={isVariableColour}
                                type={isGroup ? devicesIcons.LIGHT_DOUBLE : devicesIcons.LIGHT}
                            />
                            {isOn ? (
                                <FormattedMessage {...messages.on} values={{ brightness: value }}>
                                    {message => <FlipperMessage>{message}</FlipperMessage>}
                                </FormattedMessage>
                            ) : (
                                <FormattedMessage {...messages.off}>
                                    {message => <FlipperMessage>{message}</FlipperMessage>}
                                </FormattedMessage>
                            )}
                        </FlipperContent>
                    </BounceEffect>
                </div>
            </Flipper>
        </BrightnessFlipperContent>
    </BrightnessFlipperWrapper>
);

export default BrightnessFlipper;



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/brightness-flipper/component.js